import { Skeleton } from 'ui/skeleton';

export function ConversionGraphSkeleton() {
  return (
    <div className="flex w-full flex-col gap-6 mt-6 lg:flex-row">
      <div className="flex-1 rounded-sm border border-border-subtle bg-card p-6">
        <div className="mb-6 flex items-center justify-between">
          <Skeleton className="h-6 w-32" />
          <Skeleton className="h-9 w-[140px]" />
        </div>
        <div className="flex h-[250px] items-end gap-3 border-b border-l border-border-soft px-3 pb-2">
          {Array.from({ length: 20 }).map((_, index) => (
            <Skeleton key={index} className="flex-1 rounded-t-sm" style={{ height: `${25 + (index % 7) * 12}%` }} />
          ))}
        </div>
      </div>

      <div className="w-full rounded-sm border border-border-subtle bg-card p-6 lg:w-[320px]">
        <Skeleton className="mb-5 h-4 w-40" />
        <div className="space-y-5">
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="space-y-2">
              <div className="flex justify-between">
                <Skeleton className="h-3 w-24" />
                <Skeleton className="h-3 w-8" />
              </div>
              <Skeleton className="h-1.5 w-full rounded-full" />
            </div>
          ))}
        </div>
        <div className="my-6 border-t border-border-soft" />
        <Skeleton className="mb-5 h-4 w-36" />
        <div className="space-y-4">
          {Array.from({ length: 3 }).map((_, index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Skeleton className="size-2 rounded-full" />
                <Skeleton className="h-3 w-20" />
              </div>
              <Skeleton className="h-3 w-8" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
